<template>
  <form>
    <RiskAssessmentForm
      :name="network.name"
      :type="network.type"
      :sections="displayedSections"
      :interventions="displayedInterventions"
      :suggestions="displayedSuggestions"
      :editable="editable"
      @check="mutableSections = $event"
    />
  </form>
</template>

<script>
import RiskAssessmentForm from '@/components/sites/riskAssessments/RiskAssessmentForm.vue';

export default {
    name: 'RiskAssessmentCoolingNetworkForm',
    components: {
        RiskAssessmentForm,
    },
    props: {
        sections: {
            type: Array,
            default: () => [],
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            interventionsRules: [
                {
                    rule: 4,
                    conditions: [
                        { key: 'R2', value: true },
                        { key: 'R3', value: true },
                        { key: 'R5', value: true },
                        { key: 'R6', value: true },
                        { key: 'R9', value: true },
                        { key: 'R10', value: true },
                    ],
                    risk: this.$t('riskAnalysis.coolingNetwork.interventions.cleaningRequired'),
                },
            ],
            displayedSections: [
                {
                    name: this.$t('riskAnalysis.physicalInspection'),
                    fields: [
                        {
                            key: 'R1',
                            label: this.$t('riskAnalysis.coolingNetwork.woodConstruction'),
                            yesValue: 1,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R2',
                            label: this.$t('riskAnalysis.coolingNetwork.mudPresence'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R3',
                            label: this.$t('riskAnalysis.coolingNetwork.slimePresence'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R4',
                            label: this.$t('riskAnalysis.coolingNetwork.activeCorrosion'),
                            yesValue: 2,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R5',
                            label: this.$t('riskAnalysis.coolingNetwork.algaePresence'),
                            yesValue: 2,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R6',
                            label: this.$t('riskAnalysis.coolingNetwork.biofilmPresence'),
                            yesValue: 2,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R7',
                            label: this.$t('riskAnalysis.coolingNetwork.sunlightProtected'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                        {
                            key: 'R8',
                            label: this.$t('riskAnalysis.coolingNetwork.leaks'),
                            yesValue: 1,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R9',
                            label: this.$t('riskAnalysis.coolingNetwork.nearAirIntake'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R10',
                            label: this.$t('riskAnalysis.coolingNetwork.nearPopulationAtRisk'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                    ],
                },
                {
                    name: this.$t('riskAnalysis.applicationConditions'),
                    fields: [
                        {
                            key: 'R11',
                            label: this.$t('riskAnalysis.coolingNetwork.blowdownControl'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'R12',
                            label: this.$t('riskAnalysis.coolingNetwork.inhibitorInjectionControl'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'R13',
                            label: this.$t('riskAnalysis.coolingNetwork.oxidizingBiocide'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'R14',
                            label: this.$t('riskAnalysis.coolingNetwork.legionellaBiocide'),
                            yesValue: 0,
                            noValue: 3,
                            value: null,
                        },
                        {
                            key: 'R15',
                            label: this.$t('riskAnalysis.coolingNetwork.biocideControl'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                        {
                            key: 'R16',
                            label: this.$t('riskAnalysis.coolingNetwork.sideStreamFiltration'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                        {
                            key: 'R17',
                            label: this.$t('riskAnalysis.coolingNetwork.intermittentFlowLess1'),
                            yesValue: 3,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R18',
                            label: this.$t('riskAnalysis.coolingNetwork.intermittentFlowMore1'),
                            yesValue: 1,
                            noValue: 0,
                            value: null,
                        },
                        {
                            key: 'R19',
                            label: this.$t('riskAnalysis.coolingNetwork.dailyTesting'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'R20',
                            label: this.$t('riskAnalysis.coolingNetwork.manualAvailable'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                        {
                            key: 'R21',
                            label: this.$t('riskAnalysis.coolingNetwork.safetyEquipmentOnSite'),
                            yesValue: 0,
                            noValue: 1,
                            value: null,
                        },
                    ],
                },
                {
                    name: this.$t('riskAnalysis.analyticalResults'),
                    fields: [
                        {
                            key: 'R22',
                            label: this.$t('riskAnalysis.coolingNetwork.legionellaUndetected'),
                            yesValue: 0,
                            noValue: 5,
                            value: null,
                        },
                        {
                            key: 'R23',
                            label: this.$t('riskAnalysis.coolingNetwork.bacteriaCount'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'R24',
                            label: this.$t('riskAnalysis.coolingNetwork.minimalConcentration'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'R25',
                            label: this.$t('riskAnalysis.coolingNetwork.AdequateMineralMass'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                        {
                            key: 'R26',
                            label: this.$t('riskAnalysis.coolingNetwork.lsiCalculated'),
                            yesValue: 0,
                            noValue: 2,
                            value: null,
                        },
                    ],
                },
            ],
            mutableSections: this.sections,
            network: {
                name: null,
                type: null,
            },
            riskAnalysis: {
                network: null,
                fields: [],
            },
        };
    },
    computed: {
        displayedInterventions() {
            const displayedInterventions = [];

            this.interventionsRules.forEach(rule => {
                let t = 0;

                rule.conditions.forEach(condition => {
                    if (this.results(condition.key) === condition.value) t += 1;
                });

                if (t > rule.rule) displayedInterventions.push(rule.risk);
            });

            if (this.results('R13') === false && this.results('R14') === false && this.results('R15') === false) {
                displayedInterventions.push(this.$t('riskAnalysis.coolingNetwork.interventions.biocideReview'));
            }
            if (this.results('R22') === false) {
                displayedInterventions.push(this.$t('riskAnalysis.coolingNetwork.interventions.disinfectionRequired'));
            }

            return displayedInterventions;
        },
        displayedSuggestions() {
            const displayedSuggestions = [];

            if (this.results('R2')) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.descalingTower'));
            }
            if (this.results('R1') && this.results('R4')) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.passivationSurfaces'));
            }
            if (this.results('R5') && this.results('R7') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.installingLids'));
            }
            if (this.results('R6')) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.useBioDispersant'));
            }
            if (this.results('R11') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.automationPurge'));
            }
            if (this.results('R12') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.automationInhibitor'));
            }
            if (this.results('R15') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.automationBiocide'));
            }
            if (this.results('R2') && this.results('R16') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.continuousFiltration'));
            }
            if (this.results('R19') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.increaseChecks'));
            }
            if (this.results('R21') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.aquireEquipment'));
            }
            if (this.results('R23') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.checkBiocide'));
            }
            if (this.results('R25') === false && this.results('R26') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.reduceConcentration'));
            }
            if (this.results('R4') && this.results('R18') && this.results('R24') === false) {
                displayedSuggestions.push(this.$t('riskAnalysis.coolingNetwork.suggestions.verifyCondensateContamination'));
            }

            return displayedSuggestions;
        },
        fields() {
            const fields = [];

            this.displayedSections.forEach(section => {
                section.fields.forEach(field => {
                    fields.push({ fieldID: field.key, value: field.value });
                });
            });

            return fields;
        },
        results() {
            return fieldID => this.fields.find(field => field.fieldID === fieldID).value;
        },
    },
    watch: {
        fields() {
            this.riskAnalysis.fields = this.fields;
            this.updateData();
        },
    },
    created() {
        this.network.name = this.$attrs.name;
        this.network.type = this.$attrs.type;
        if (this.$attrs.component) {
            this.network.name = this.$attrs.componentName;
            this.network.type = this.$attrs.componentType;
            this.riskAnalysis.component = this.$attrs.component;
        }
        this.riskAnalysis.network = this.$attrs.network;

        if (this.mutableSections.length) {
            this.displayedSections = this.displayedSections.map((section, i) => ({
                ...section,
                fields: this.transformFields(i, section.fields),
            }));
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.riskAnalysis);
        },
        transformFields(i, fields) {
            return fields.map((field, j) => ({
                ...field,
                value: this.mutableSections[i].fields[j].value,
            }));
        },
    },
};
</script>
